import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from "@angular/router";
import { IRequest } from "../pages/portabilidadweb/Request";
import { IResponse } from "../pages/portabilidadweb/Response";
import { environment } from "../../environments/environment";
import { IKeyDTO } from '../pages/portabilidadweb/KeyDTO';
import { IToken } from "../pages/portabilidadweb/Token";


@Injectable({ providedIn: 'root' })
export class LoginService {

  authenticated = true;

  private readonly sessionToken: string | null = null;
  
  constructor(private readonly router: Router, private readonly http: HttpClient) { }

  key(): Observable<IKeyDTO> {

    return this.http.post<IKeyDTO>(environment.apiUrl+'/security/ky', {});
  }

  siginAuth(response: IRequest): Observable<IResponse> {
    return this.http.post<IResponse>(environment.apiUrl+'/auth/login', response);
  }

  signout() {
    this.authenticated = false;
     this.router.navigateByUrl("/home/inicio");
  }

  guardarCredenciales(token: string, rut: string): void {
    localStorage.setItem('token', token);
    localStorage.setItem('rut', rut);
  }

  obtenerToken(): string | null {
    return localStorage.getItem('token');
  }

  obtenerRut(): string | null {
    return localStorage.getItem('rut');
  }

  eliminarCredenciales(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('rut');
  }

  isTokenExpired(token: string): boolean {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expirationDate = new Date(payload.exp * 1000);
    return expirationDate < new Date();
  }

  
  getSessionToken(): Observable<IToken> {
    const headers = new HttpHeaders({
        'Accept': 'application/json' // Asegura que el backend devuelva JSON
    });

    return this.http.get<IToken>(`${environment.apiUrl}/token-csrf`, {
        headers: headers,
        withCredentials: true // Permite que el navegador envíe las cookies de sesión
    });
}


}
